/* eslint-disable react/require-default-props */
import React from 'react';
import { IconModalClose } from '../assets/IconModalClose';

interface SmlsModalHeaderCustomProps {
  showBackButton?: boolean;
  onBack?: () => void;
  backId?: string;
  showCloseButton?: boolean;
  onClose?: () => void;
  closeId?: string;
}

export function TangModalHeader({
  showBackButton = false,
  onBack = () => null,
  showCloseButton = false,
  onClose = () => null,
  backId = '',
  closeId = '',
}: SmlsModalHeaderCustomProps) {
  return (
    <div data-testid="custom-header" className="custom-modal-header tang-modal-header">
      <div className="header-button-back">
        {showBackButton && (
          <button
            data-testid="btn_back-testid"
            id={backId}
            type="button"
            className="smls-btn-close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={onBack}
          >
            <i className="material-icons">&#xe314;</i>
          </button>
        )}
      </div>

      <div className="header-button-close">
        {showCloseButton && (
          <button
            id={closeId}
            type="button"
            className=""
            data-dismiss="modal"
            aria-label="Close"
            onClick={onClose}
          >
            <IconModalClose />
          </button>
        )}
      </div>
    </div>
  );
}
